<script>
    import EquipmentCard from "./equipment_card.svelte"
    import {get_sensors, get_sensor_messages} from '../gqlQueries'
    import {from, of, EMPTY} from "rxjs"
    import {mergeMap, tap, map, catchError, toArray} from "rxjs/operators";
    import {getSensorInformation, getMultiple, getRef, DEFAULT_SENSOR_INFOS} from "../firestore";
    import {getPercentage} from "../utils";

    let sensors = [];
    let displaySensors = [];

    let sort_by;
    let filter_material;
    let filter_state;

    function sortByLevel(a, b, ascending = true) {
        let percentage_a = getPercentage(a);
        let percentage_b = getPercentage(b);

        if (isNaN(percentage_a)) return 1;
        if (isNaN(percentage_b)) return -1;

        if (ascending) return percentage_a - percentage_b;
        else return percentage_b - percentage_a;
    }

    function filterByState(sensor, filter) {
        let percentage = getPercentage(sensor) * 100;

        if (isNaN(percentage)) return false;

        let state;
        if (percentage < sensor.infos.thresholds.danger.value) state = "danger";
        else if (percentage < sensor.infos.thresholds.warning.value) state = "warning";
        else state = "success";

        return state === filter;
    }

    $: sort_sensors(sensors, sort_by, filter_material, filter_state);

    function sort_sensors(_sensors, _sort_by, _filter_material, _filter_state) {
        displaySensors = _sensors.slice();

        switch (_filter_material) {
            case "Gazoline":
                displaySensors = displaySensors.filter(sensor => sensor.infos.type === "Gazoline");
                break;
            case "Water":
                displaySensors = displaySensors.filter(sensor => sensor.infos.type === "Water");
                break;
        }

        switch (_filter_state) {
            case "Normal":
                displaySensors = displaySensors.filter(sensor => filterByState(sensor, "success"));
                break;
            case "Low":
                displaySensors = displaySensors.filter(sensor => filterByState(sensor, "warning"));
                break;
            case "Low-low":
                displaySensors = displaySensors.filter(sensor => filterByState(sensor, "danger"));
                break;
        }

        switch (_sort_by) {
            case "Equipment #":
                displaySensors = displaySensors.slice().sort((a, b) => a._id - b._id);
                break;
            case "Equipment Name":
                displaySensors = displaySensors.slice().sort((a, b) => a.infos.name.localeCompare(b.infos.name));
                break;
            case "Level (Critical to Normal)":
                displaySensors = displaySensors.slice().sort((a, b) => sortByLevel(a, b, true));
                break;
            case "Level (Normal to Critical)":
                displaySensors = displaySensors.slice().sort((a, b) => sortByLevel(a, b, false));
                break;
        }
    }

    get_sensors({sort: false, array: false, messages: false, last_message: true}).pipe(
        map(sensor => ({...sensor, messages: [], infos: DEFAULT_SENSOR_INFOS})),
        mergeMap(sensor =>
            from(getSensorInformation({id: sensor.id})).pipe(
                map(sensorInformation => ({
                    ...sensor,
                    infos: sensorInformation
                })),
                tap(sensor => {
                    let index = sensors.findIndex(sen => sen.id === sensor.id);
                    sensors[index] = ({...sensors[index], infos: sensor.infos});
                }),
                catchError(() => of(sensor))
            )
        ),
        toArray(),
        tap(sensorArray => sensors = [...sensorArray]),
        mergeMap(sensorArray => from(sensorArray)),
        mergeMap(sensor =>
            from(get_sensor_messages({id: sensor.id}))
                .pipe(
                    map(sensorMessages => ({...sensor, messages: sensorMessages.messages})),
                    tap(sensor => {
                        let index = sensors.findIndex(sen => sen.id === sensor.id);
                        sensors[index] = ({...sensors[index], messages: sensor.messages})
                    }),
                    catchError(() => of(sensor))
                )
        ),
    ).subscribe(() => {
        sensors = [...sensors];
    });

</script>

<svelte:head><title>Axces2 - Equipment summary</title></svelte:head>

{#if sensors.length > 0}
    <div class="container-fluid">

        <div class="row page-titles">
            <div class="col-md-5 col-8 align-self-center">
                <h3 class="text-themecolor">Equipment Summary</h3>
                <ol class="breadcrumb">

                    <li class="breadcrumb-item">Sites Overview</li>
                    <li class="breadcrumb-item active">Equipment Summary</li>
                </ol>
            </div>
        </div>

        <section>
            <div class="row">
                <div class="col-sm-12 text-right">
                    <div class="filters-row">
                        <label>View</label>
                        <select bind:value={filter_state}>
                            <option selected>-- All States --</option>
                            <option>Normal</option>
                            <option>Low</option>
                            <option>Low-low</option>
                        </select>

                        <label>Material Type</label>
                        <select bind:value={filter_material}>
                            <option selected>-- All Types --</option>
                            <option>Gazoline</option>
                            <option>Water</option>
                        </select>

                        <label>Sort By</label>
                        <select bind:value={sort_by}>
                            <option selected>Level (Critical to Normal)</option>
                            <option>Level (Normal to Critical)</option>
                            <option>Equipment #</option>
                            <option>Equipment Name</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row padding-top">
                {#each displaySensors as sensor, i(sensor.id)}
                    <EquipmentCard equipment={sensor}/>
                {/each}
            </div>
        </section>
    </div>
{:else}
    <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
    </svg>
{/if}
